export * from './PrivacyPolicy';
export * from './TermsAndConditions';
